module.exports = __webpack_public_path__ + "img/first_one.4fdbff45.png";